// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__21j5M","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2DDbs","obliqueLine":"membershipbadge_obliqueLine__tO-I-"};